import { Link } from 'react-router-dom'
import React from 'react'
import frame from '../../../assets/images/about-frame.png'
import screen from '../../../assets/images/about-screen.png'
import img1 from '../../../assets/images/download.png'
import img2 from '../../../assets/images/followers.png'
import img3 from '../../../assets/images/reviews.png'
import img4 from '../../../assets/images/countries.png'

const Main = ({video , dark}) => {
  return (
    <>
        <section className="row_am about_app_section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="about_img"  data-aos-duration="1500">
                        <div className="frame_img">
                            <img className="moving_position_animatin" src={frame} alt="image"/>
                        </div>
                        <div className="screen_img">
                            <img className="moving_animation" src={screen} alt="image" />
                        </div>
                        </div>
                    </div>                   
                    <div className="col-lg-6">
                        <div className="about_text">
                        <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                            <h2>Track the progress of everything <span>and anything.</span></h2>
                            <p>
                            Track the progress of your project however you prefer. Accord is extremely dynamic allowing your users to generate there own custom reports as well as having a standard set for all users to see and collaborate on.
                            </p>
                        </div>
                        {dark ?
                            <ul className="list">
                                <li  data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Simply dummy text of the printing and 
                                </li>
                                <li  data-aos-duration="1500">
                                <i className="icofont-verification-check"></i> Typesetting industry lorem Ipsum has been the 
                                </li>
                                <li  data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Industrys standard dummy text 
                                </li>
                                <li  data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Simply dummy text of the printing and 
                                </li>
                                <li  data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Typesetting industry lorem Ipsum has been the 
                                </li>
                             </ul>
                             :
                            <ul className="app_statstic" id="counter"  data-aos-duration="1500">
                                <li>
                                <div className="icon">
                                {video ? <img src="/assets/images/download-one.png" alt="image" /> : <img src={img1} alt="image" />} 
                                </div>
                                <div className="text">
                                    <p><span className="counter-value" data-count="36">36</span><span></span></p>
                                    <p>Charts/Graph Types</p>
                                </div>
                                </li>
                                <li>
                                <div className="icon">
                                {video ? <img src="/assets/images/followers-one.png" alt="image" /> : <img src={img2} alt="image" /> }
                                </div>
                                <div className="text">
                                    <p><span className="counter-value" data-count="1000">1000 </span><span>+</span></p>
                                    <p>Datapoints</p>
                                </div>
                                </li>
                                <li>
                                <div className="icon">
                                    {video ? <img src="/assets/images/reviews-one.png" alt="image" /> : <img src={img3} alt="image" /> }
                                </div>
                                <div className="text">
                                    <p><span className="counter-value" data-count="22">22</span><span>M+</span></p>
                                    <p>Inspections Completed</p>
                                </div>
                                </li>
                                <li>
                                <div className="icon">
                                    {video ? <img src="/assets/images/countries-one.png" alt="image" /> : <img src={img4} alt="image" /> }
                                </div>
                                <div className="text">
                                    <p><span className="counter-value" data-count="8">8</span><span>M+</span></p>
                                    <p>Project Savings so far</p>
                                </div>
                                </li>
                            </ul>}
                            <a href="https://www.fnvi.app/register" className="btn puprple_btn"  data-aos-duration="1500">Get onboard! </a>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </>
  )
}

export default Main